"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.continuityLogPayloadSchema = exports.findingContinuityLogPayloadSchema = exports.assertionResultContinuityLogPayloadSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("../enums");
exports.assertionResultContinuityLogPayloadSchema = zod_1.z.object({
    kind: zod_1.z.literal('assertion-result-continuity'),
    previousAssertionResultId: zod_1.z.string(),
    previousBuildId: zod_1.z.string(),
    inheritedWorkflowState: enums_1.RequirementWorkflowStateSchema.nullable(),
});
exports.findingContinuityLogPayloadSchema = zod_1.z.object({
    kind: zod_1.z.literal('finding-continuity'),
    findingId: zod_1.z.string(),
    newAssertionResultId: zod_1.z.string().nullable(),
    previousAssertionResultId: zod_1.z.string().nullable(),
    previousBuildId: zod_1.z.string().nullable(),
    disposition: enums_1.FindingContinuityDispositionSchema.default(enums_1.FindingContinuityDisposition.Reproduced),
    reason: zod_1.z.string().nullable().default(null),
});
exports.continuityLogPayloadSchema = zod_1.z.discriminatedUnion('kind', [
    exports.assertionResultContinuityLogPayloadSchema,
    exports.findingContinuityLogPayloadSchema,
]);
//# sourceMappingURL=continuity-log-payload.js.map